<template>
	<div class="drawer">
		<el-drawer
		v-if="yuyueId"
		size="363px"
		title="是否到店"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<img src="../../../../assets/img/remark.png" class="avatar"/>
			<div style="padding-bottom:40px;">
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="24">
						<span class="label">是否到店：</span>
						<span class="value">
							<el-select style="width:200px;"  class="select" v-model="arrive" placeholder="请选择">
								<el-option v-for="item in [{value:1,label:'顾客已到店'},{value:0,label:'顾客没有到店'}]" :key="item.value"
								:label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</span>
					</el-col>
				</el-row>
				<div>
					<el-button style="width:280px;margin:80px 0 0 40px;" type="primary" size="mini" @click="submit_arrive">确 定</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				arrive:1,
			}
		},
		props:{
			yuyueId:{
				default:''
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submit_arrive(){
				if(this.arrive===1){ // 已到店
					let params = {
						id:this.yuyueId,
					}
					this.$http.get('/api/Reservation/Complete', params).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit('submit',{type:'success'})
						}
					})
				}else if(this.arrive===0){  // 未到店
					let params = {
						id:this.yuyueId,
					}
					this.$http.get('/api/Reservation/Notto', params).then(res => {
						if (res.code == 0) {
							this.$message({
								message: '操作成功',
								type: 'success'
							});
							this.$emit('submit',{type:'success'})
						}
					})
				}
				this.arrive = 1;
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.avatar{
				width:220px;
				display: block;
				margin:150px auto 80px;
			}
			.label{
				display: inline-block;width:100px;text-align: right;
			}
		}
		
	}
	
</style>
